var Backbone = require('backbone');
var Marionette = require('marionette');
var Dialog = require('Dialog');
var Labels = EY.Consultation.Labels;

var Layout = Marionette.View.extend({
    regions: {
        available: '#available',
        map: '#map',
        mapped: '#mapped',
        rank: '#rank'
    },
    template: '#approverMapping'
});

var MappingItem = Marionette.View.extend({
    className: 'list-group-item',
    events: {
        'click': 'selected'
    },
    modelEvents: {
        'change:selected': 'update'
    },
    tagName: 'li',
    template: '#approverMappingItem',
    ui: {
        name: '#name'
    },
    onRender: function () {
        this.$el.addClass(this.model.get('configurable') ? '' : 'hidden');
        this.ui.name.html(Labels['ApproverGroup_' + this.model.id]);
        this.update();
    },
    selected: function () {
        var context = this;

        context.model.collection.each(function (model) {
            model.set('selected', model.id == context.model.id);
        });
    },
    update: function () {
        this.model.get('selected') ? this.$el.addClass('mappingSelection') : this.$el.removeClass('mappingSelection');
    }
});

var MappingList = Marionette.CollectionView.extend({
    className: 'list-group',
    childView: MappingItem,
    tagName: 'ul'
});

var Editor = Marionette.View.extend({
    events: {
        'click @ui.lookup': function () { this.model.set('lookup', this.ui.lookup.prop('checked')); },
        'click @ui.multiple': function () { this.model.set('multiple', this.ui.multiple.prop('checked')); },
        'click @ui.picklist': function () { this.model.set('picklist', this.ui.picklist.prop('checked')); },
        'click @ui.rank': function () { this.model.set('rank', this.ui.rank.prop('checked')); },
        'click @ui.required': 'required',
        'click @ui.visible': 'visible'
    },
    template: '#editApproverMapping',
    ui: {
        lookup: '#lookup',
        multiple: '#multiple',
        name: '#name',
        picklist: '#picklist',
        rank: '#rank',
        required: '#required',
        visible: '#visible'
    },
    onRender: function () {
        this.ui.lookup.prop('checked', this.model.get('lookup'));
        this.ui.multiple.prop('checked', this.model.get('multiple'));
        this.ui.name.html(Labels.Name + ': ' + Labels['ApproverGroup_' + this.model.id]);
        this.ui.picklist.prop('checked', this.model.get('picklist'));
        this.ui.rank.prop('checked', this.model.get('rank'));
        this.ui.required.prop('checked', this.model.get('required'));
        this.ui.visible.prop('checked', this.model.get('visible'));
    },
    required: function () {
        var checked = this.ui.required.prop('checked');

        if (checked) {
            this.ui.visible.prop('checked', true);
            this.model.set('visible', true);
        }
        this.model.set('required', checked);
    },
    visible: function () {
        var checked = this.ui.visible.prop('checked');

        if (!checked) {
            this.ui.required.prop('checked', false);
            this.model.set('required', false);
        }
        this.model.set('visible', checked);
    }
});

var EditMappingItem = MappingItem.extend({
    events: {
        'click': 'selected',
        'click @ui.edit': 'edit'
    },
    template: '#approverMappingEditItem',
    ui: {
        edit: '#edit',
        name: '#name'
    },
    edit: function () {
        var model = this.model;
        var attributes = model.clone().attributes;

        Dialog.show({
            cancelLabel: Labels.Cancel,
            headerLabel: Labels.EditApprover,
            saveLabel: Labels.OK,
            view: new Editor({
                model: this.model
            })
        }).fail(function () {
            model.set(attributes);
        });
    }
});

var EditMappingList = MappingList.extend({
    childView: EditMappingItem
});

var Move = Marionette.View.extend({
    events: {
        'click @ui.left': 'moveLeft',
        'click @ui.right': 'moveRight'
    },
    ui: {
        left: '#moveLeft',
        right: '#moveRight'
    },
    template: '#approverMappingButton',
    moveRight: function () {
        var left = this.options.left;
        var right = this.options.right;
        var rankField = this.options.rankField;
        var selected = left.findWhere({ selected: true });

        if (selected) {
            selected.set('selected', false).set(rankField, right.last() ? right.last().get(rankField) + 1 : 1);
            right.add(left.remove(selected));
        }
        this.rank();
    },
    moveLeft: function () {
        var left = this.options.left;
        var rankField = this.options.rankField;
        var right = this.options.right;
        var selected = right.findWhere({ selected: true });

        if (selected) {
            selected.set('selected', false).set(rankField, 0);
            left.add(right.remove(selected));
        }
        this.rank();
    },
    rank: function () {
        var index = 1;
        var rankField = this.options.rankField;
        var right = this.options.right;

        right.each(function (model) {
            model.set(rankField, index++);
        });
    }
});

var Rank = Marionette.View.extend({
    events: {
        'click @ui.up': 'moveUp',
        'click @ui.down': 'moveDown'
    },
    ui: {
        up: '#moveUp',
        down: '#moveDown',
        buttons: 'button'
    },
    template: '#approverMappingRank',
    initialize: function () {
        this.collection.comparator = this.options.rankField;
    },
    moveUp: function () {
        this.move(true);
    },
    moveDown: function () {
        this.move(false);
    },
    move: function (ascend) {
        var rankField = this.options.rankField;
        var selected = this.collection.findWhere({ selected: true });
        var index = this.collection.indexOf(selected);

        if (selected && (ascend ? index > 0 : index < this.collection.length - 1)) {
            var rank = selected.get(rankField);
            var other = this.collection.at(ascend ? index - 1 : index + 1);

            selected.set(rankField, other.get(rankField));
            other.set(rankField, rank);
        }
        this.collection.sort();
    }
});

module.exports.start = function (options) {
    var available = options.available || new Backbone.Collection();
    var mapped = options.mapped || new Backbone.Collection();
    var rankField = options.rankField || 'order';
    var region = options.region;
    var layout = new Layout();

    region.show(layout);
    layout.getRegion('available').show(new MappingList({
        collection: available
    }));
    layout.getRegion('mapped').show(new EditMappingList({
        collection: mapped
    }));
    layout.getRegion('map').show(new Move({
        left: available,
        right: mapped,
        rankField: rankField
    }));
    layout.getRegion('rank').show(new Rank({
        collection: mapped,
        rankField: rankField
    }));
};


// WEBPACK FOOTER //
// ./js/Modules/Questionnaire/QuestionnaireApprovers.js